/**
 * List of variants for Tag
 */
export var TagVariant;
(function (TagVariant) {
    TagVariant["SUCCESS"] = "SUCCESS";
    TagVariant["INFO"] = "INFO";
    TagVariant["ERROR"] = "ERROR";
    TagVariant["WARNING"] = "WARNING";
})(TagVariant || (TagVariant = {}));
/**
 * List of variants background styles for Tag
 */
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFnRW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvdGFnL1RhZ0VudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxVQUtYO0FBTEQsV0FBWSxVQUFVO0lBQ3BCLGlDQUFtQixDQUFBO0lBQ25CLDJCQUFhLENBQUE7SUFDYiw2QkFBZSxDQUFBO0lBQ2YsaUNBQW1CLENBQUE7QUFDckIsQ0FBQyxFQUxXLFVBQVUsS0FBVixVQUFVLFFBS3JCO0FBT0Q7O0dBRUcifQ==